import React from "react";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import BreadCrumb from '../../components/BreadCrumb';

const ApplicationDevelopment = () => {
    return (
        <div>
            <Navbar />
                <div class="container">
                    <BreadCrumb 
                        active_page="Application Development" 
                        prev_sub_page={{
                            'link':'/services',
                            'text':'Services'
                        }}
                        sub_page={{
                            'link':'/services/it-development-consulting',
                            'text':'IT Development & Consulting'
                        }} 
                    />
                    <div class="inner-container">
                        <h2>Application Development</h2>
                        
                        <h3>Build Solutions That Grow Along With You</h3>
                        <p>Navigate through your business challenges with latest tech trends. We are agile implementers and we adopt the incremental and iterative process of application development.</p>
                        <h3>Integrated Development Envirnoment</h3>
                        <p>Always build things that work together. We create a framework that enables faster development and productivity. This adds more precision to our work while streamlining the entire process.</p>
                        <h3>Reliable & Rapid</h3>
                        <p>Streamlined delivery with cost effective engagements those would match your goals, timelines, and budgets.</p>
                        <h3>Deliver Incrementally, Instead Of All At Once</h3>
                        <p>We follow the agile development methodology which concentrates on</p>
                        <ol>
                            <li>Creating functional capabilities that are aggregated to fulfil the business requirements</li>
                            <li>Scrum framework that guides the application development</li>
                            <li>Sprints to deliver functions within a finite time</li>
                        </ol>
                        <img alt="" src={require('../../assets/images/services/application-development.png')} width="100%"/>

                    </div>
                </div>
            <Footer />
        </div>
    );
};

export default ApplicationDevelopment;